import { useEffect, useRef, useState } from "react";
import { Bell } from "lucide-react";
import { apiGet, apiPost } from "@/lib/apiAdmin";

const ago = (iso) => new Date(iso).toLocaleString("en-US", { timeZone: "America/Phoenix", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const AlertsBell = () => {
  const [d, setD] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const load = () => apiGet("/admin/alerts").then(setD).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    const esc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); };
  }, []);
  const toggle = () => { setOpen(!open); if (!open && d.unread) apiPost("/admin/alerts/read", {}).then(() => setD({ ...d, unread: 0 })); };
  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} className="relative w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-gray-300 hover:text-white" data-testid="admin-alerts-bell">
        <Bell className="w-4 h-4" />
        {d.unread > 0 && <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-sky-500 text-[10px] text-white flex items-center justify-center" data-testid="admin-alerts-unread">{d.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto rounded-2xl border border-white/10 bg-[#0b0d10] shadow-2xl z-50" data-testid="admin-alerts-list">
          {d.items.length === 0 ? <p className="p-4 text-sm text-gray-500">No alerts yet.</p> : d.items.map((a) => (
            <div key={a.alert_id} className="p-3 border-b border-white/5">
              <p className="text-sm text-white">{a.title}</p>
              {a.body && <p className="text-xs text-gray-400">{a.body}</p>}
              <p className="text-[10px] text-gray-500 mt-1">{ago(a.created_at)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
